// src/libs/appCodeGA4.ts

/**
 * Interface for validation parameters
 */
interface ValidationParams {
 leadDropValidationPassed?: boolean;
 peDemandSub?: boolean;
}

/**
 * Determines the appropriate app code for GA4 tracking based on user state and validation parameters
 *
 * App Code Logic:
 * - 98: User NOT logged in (no email)
 * - 99: User IS logged in (has email) OR (leadDropValidationPassed && peDemandSub are both true)
 * - 151: Special case for logged out users with registration form ( on a asset page )
 *
 * @param userEmail - User's email (string if logged in, false if not)
 * @param validationParams - Object containing validation parameters
 * @returns The appropriate app code as a string
 */
export function getAppCode(
 userEmail: string | false | undefined,
 validationParams: ValidationParams = {},
 page?: string,
): string {
 const { leadDropValidationPassed, peDemandSub } = validationParams;

 // Special case: If leadDropValidationPassed && peDemandSub both true
 if (leadDropValidationPassed && peDemandSub && page === 'asset') {
  return '99';
 }

 // Special case: User is logged out AND registration form is shown
 if (!userEmail && page === 'asset') {
  return '151'; // needs updating to new code - DONT use 151! 
 }

 // Basic logic: User is logged in & no form showing = 99, not logged in & no form showing = 98
 return userEmail ? '99' : '98';
}

